import styled from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import { createReadableClass } from '@elfsight/widget-utils';
import { ellipsisMixin } from '../../mixins';
import type { CounterProps } from './counter';
import { Counter } from './counter';

export type UnitProps = {
  children: CounterProps['children'];
  size: number;
  unitStyle: CounterProps['counterStyle'];
  animation: CounterProps['animation'];
  color: CounterProps['color'];
  backgroundColor: CounterProps['backgroundColor'];
  showLabels: boolean;
  labelText: string;
  labelColor: string;
};

export function Unit({
  children,
  size,
  unitStyle,
  color,
  backgroundColor,
  showLabels,
  labelText,
  labelColor,
  animation
}: UnitProps) {
  return (
    <Container _size={size}>
      <Counter
        counterStyle={unitStyle}
        color={color}
        backgroundColor={backgroundColor}
        animation={animation}
      >
        {children}
      </Counter>

      <Show when={showLabels}>
        <Label _color={labelColor}>{labelText}</Label>
      </Show>
    </Container>
  );
}

const Container = styled.div.attrs<{ _size: number }>({
  className: createReadableClass({
    component: 'unit',
    element: 'container'
  })
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: ${({ _size }) => _size}px;
  gap: 0.125em;
  min-width: 1.875em;
`;

const Label = styled.div.attrs<{ _color: string }>({
  className: createReadableClass({
    component: 'unit',
    element: 'label'
  })
})`
  ${ellipsisMixin};
  color: ${({ _color }) => _color};
  font-size: max(8px, 0.34375em);
  line-height: 1.27273;
  max-width: 5.454em;
`;
